'use client';

import { useDevice } from './use-device';
import { APP_STORE_URL, PLAY_STORE_URL } from './app-store-urls';

/**
 * Hook to handle download action based on device type
 * @returns Object with handleDownload function and shouldShowModal boolean
 */
export function useDownloadAction() {
  const device = useDevice();

  const handleDownload = (onShowModal?: () => void) => {
    if (device === 'ios') {
      window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer');
    } else if (device === 'android') {
      window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer');
    } else {
      // Desktop: show QR code modal
      onShowModal?.();
    }
  };

  return {
    handleDownload,
    isMobile: device === 'ios' || device === 'android',
  };
}
